/**
 * Toolbar - Maintenance Mode class
 *
 * Responsible for the maintenance mode button in the toolbar + associated dropdown layer
 */
/*global Klazz, diy, jimdoData */

var $ = require('jquery');
var model = require('diy/maintenanceMode/maintenanceMode');
var Widget = require('diy/maintenanceMode/MaintenanceModeWidget');
var features = require('diy/util/features');
var l10n = require('diy/util/l10n');
var NotificationApi = require('diy/toolbar/notificationNG/Api').default;
var NotificationType = require('diy/toolbar/notificationNG/definitions/Type').default;

var MaintenanceMode,
    SESSION_ID_COOKIE_NAME = 'DIY_SB',
    NTF_DISMISSED_COOKIE_PREFIX = 'diy-maintenance-ntf-dismissed-',
    /**
     * TODO: move this to a generic cookie per session id generation method
     * @see bookmark-cms.js
     * What we're doing here is enforcing the callout to not show anymore in this session if it was
     * dismissed. For this we need to persist this info for the sitebuilder session. Because the
     * sitebuilder session is smaller than the browser session we can use a browser cookie set to
     * expire on session end, also because the client may start multiple server sessions while still
     * keeping his same browser session we need to include the server session id into this cookie.
     *
     * Additionaly because the Sitebuilder may be installed on machines with the Suhosin extension
     * we must limit the cookie name to 64 chars or else the server will not accept the request.
     */
     ntfDismissedCookieName = (NTF_DISMISSED_COOKIE_PREFIX + $.cookie(SESSION_ID_COOKIE_NAME)).substr(0, 64);

MaintenanceMode = Klazz.extend({
    element: null,
    toolbar: null,
    activated: false,
    messages: {
        online: {
            heading: '',
            description: ''
        },
        offline: {
            heading: '',
            description: ''
        },
        link: ''
    },
    vCardEditor: null,

    initialize: function(vCardEditor, toolbar) {
        this.toolbar = toolbar;
        this.vCardEditor = vCardEditor;

        // get translations //
        this.messages = $.extend(true, {}, this.messages, l10n.getMessages('toolbar.maintenance')); // note: we break object reference

        // import the state of the website (public / disabled) //
        this.activated = model.getState();

        // render html structure //
        this.draw();
    },
    draw: function(){
        var elementHtml;

        // build buttons HTML //
        elementHtml = '' +
            '<div class="maintenanceModeContainer">' +
                '<a class="maintenanceMode ' + (this.activated ? 'selected' : '') + '">' +
                    '<div class="icon"' +
                        ' title="' + this.messages[ this.activated ? 'offline' : 'online' ].icon.title + '"' +
                    '></div>' +
                    '<div class="text ' + (this.activated ? 'text-offline' : 'text-online') + '">' +
                        '<span class="text-inner">' +
                            this.messages[ this.activated ? 'offline' : 'online' ].label +
                        '</span>' +
                    '</div>' +
                '</a>' +
            '</div>';

        this.element = this.toolbar.pushToPanel('left', elementHtml);
        this.element
            .diy_calloutLayer({
                cls: 'diye-toolbar-callout diye-toolbar-maintenance',
                anchorTarget: this.element.find('.icon'),
                positionMode: 'fixed',
                layerWidth: 400,
                position: {
                    my: 'left top',
                    at: 'left bottom',
                        offset: '-10 ' + (diy.editor.uiPreference.isPointerModeTouch() ? '10' : '5')
                },
                render: $.proxy(this._renderLayer, this),
                show: $.proxy(function() {
                    jQuery(document.body).trigger('PublishWebsiteOpened.BSA');
                    this.element.addClass('callout-open');
                }, this),
                hide: $.proxy(function() {
                    this.element.removeClass('callout-open');
                }, this)
            })
            .bind('click', this._toggleLayer.bind(this))
            .bind('diy-editor-toolbar-close-maintenance-mode',
                (function(){
                    this.element.diy_calloutLayer('hide')
                }).bind(this))
            .bind('diy-editor-toolbar-open-maintenance-mode',
                (function(){
                    this.element.diy_calloutLayer('show')
                }).bind(this));

        $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));

        $(document).bind('diy-maintenance-mode-changed', function(e, state) {
            if (state) {
                this.activate();
            } else{
                this.deactivate();
            }
            if (this.infoPanel) {
                // Update widget if panel is rendered
                this.widget.refresh();
            }
        }.bind(this));

        $(document).bind('diy-maintenance-loading-state-changed', function(e, state) {
            if (!this.infoPanel) {
                // Do nothing if panel is not yet rendered
                return;
            }
            if (state) {
                this.infoPanel.loadingBox({ useOverlay: true}).show();
            } else {
                this.infoPanel.loadingBox().remove();
            }
        }.bind(this));

        this.manageNotification();
    },

    _getLayerTemplate: function() {
        var stateKey = this.activated ? 'offline' : 'online';

        return '' +
            '<h3 class="heading subheading">' +
                this.messages[stateKey].heading +
            '</h3>'+
            '<div class="content">' +
                '<div class="maintenance-widget"></div>' +
                '<div class="description">' +
                    this.messages[stateKey].description +
                '</div>' +
                '<div class="maintenance-link">' +
                    '<a href="JavaScript:;">' +
                        l10n.getString('toolbar.maintenance.offline.vcard.edit.title') +
                    '</a>' +
                '</div>' +
            '</div>';
    },

    _renderLayer: function(e, layer) {
        var contentEl = layer.getContentEl();

        if (!contentEl) {
            return;
        }

        $(this._getLayerTemplate()).appendTo(contentEl);
        this.infoPanel = contentEl;

        this.widget = new Widget(this.infoPanel.find('.maintenance-widget'));

        this.vCardEditor.createTriggerElement({
            element: this.infoPanel.find('.maintenance-link').find('a'),
            context: "toolbar"
        });
    },

    show: function () {
        this.element.diy_calloutLayer('show');
    },

    _toggleLayer: function() {
        var visible = this.element.diy_calloutLayer("isVisible");
        this.element.diy_calloutLayer(visible ? 'hide' : 'show');
    },

    _positionLayer: function() {
        this.element.diy_calloutLayer('refresh');
    },

    openInSettings: function () {
        $(document).trigger('diy-editor-constructionTopbar-click');
        diy.editor.deeplinking.requestPath([
            {label: 'siteadmin', params: 'settings'},
            {label: 'SAC.Settings', params: 'website-staging'}
        ]);
    },

    activate: function () {
        this.activated = true;

        this.element.find('.maintenanceMode').addClass('selected');
        if (this.infoPanel) {
            this.infoPanel.find('.heading').html(this.messages.offline.heading);
            this.infoPanel.find('.description').html(this.messages.offline.description);
        }

        this.element.find('.maintenanceMode .text')
            .addClass('text-offline')
            .removeClass('text-online')
            .find('.text-inner')
            .html(this.messages.offline.label);

        this.element.find('.maintenanceMode .icon')
            .attr('title', this.messages.offline.icon.title );

        return this;
    },
    deactivate: function () {
        this.activated = false;

        this.element.find('.maintenanceMode').removeClass('selected');

        if (features('notificationsNG')) {
            this.removeNotification();
        } else {
            diy.editor.notifications.api.ready(function() {
                var n = diy.editor.notifications;
                n.api.deleteNotificationByType(n.Notifications.TYPE_MAINTENANCE);
            }.bind(this));
        }

        if (this.infoPanel) {
            this.infoPanel.find('.heading').html(this.messages.online.heading);
            this.infoPanel.find('.description').html(this.messages.online.description);
        }

        this.element.find('.maintenanceMode .text')
            .addClass('text-online')
            .removeClass('text-offline')
            .find('.text-inner')
            .html(this.messages.online.label);

        this.element.find('.maintenanceMode .icon')
            .attr('title', this.messages.online.icon.title );

        return this;
    },
    toggleActivation: function () {
        if (this.activated) {
            this.deactivate();
        } else {
            this.activate();
        }

        return this;
    },
    manageNotification: function() {
        // No notification on page load if we haven't published our website yet
        if (model.isFirstPublish()) {
            return;
        }

        if (!this.activated) {
            this.removeNotification();
        } else {
            this.sendNotification();
        }
    },
    sendNotification: function() {
        if (features('notificationsNG')) {
            NotificationApi.schedule(function () {

                // Here we check if we showed the notification this session. The code is copied from
                // bookmark-cms.js. Should be removed once the notification triggering system is refactored
                if (!$.cookie(ntfDismissedCookieName)) {

                    NotificationApi.pushOne({
                        type: NotificationType.MAINTENANCE_MODE,
                        dismissed: false,
                        deleted: false
                    });
                    $.cookie(ntfDismissedCookieName, '1', {path: '/'});
                }
            });

        } else {
            diy.editor.notifications.api.ready(function() {
                var n = diy.editor.notifications;
                var maintenanceNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_MAINTENANCE);
                if (maintenanceNotifications.length <= 0) {
                    n.api.createNotification({type: n.Notifications.TYPE_MAINTENANCE});
                } else {
                    // Here we check if we showed the notification this session. The code is copied from
                    // bookmark-cms.js. Should be removed once the notification triggering system is refactored
                    if ($.cookie(ntfDismissedCookieName)) {
                        return;
                    }

                    n.api.updateNotification(maintenanceNotifications[0].getId(), {dismissed: 0});
                    $.cookie(ntfDismissedCookieName, '1', {path: '/'});
                }
            }.bind(this));
        }
    },
    removeNotification: function() {
        if (features('notificationsNG')) {
            NotificationApi.schedule(function () {
                NotificationApi.deleteOne(
                    NotificationType.MAINTENANCE_MODE
                );
            });

        } else {
            diy.editor.notifications.api.ready(function() {
                var n = diy.editor.notifications;
                var maintenanceNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_MAINTENANCE);
                if (maintenanceNotifications.length > 0) {
                    n.api.deleteNotificationByType(n.Notifications.TYPE_MAINTENANCE);
                }
            }.bind(this));
        }
    },
    getCalloutWidget: function() {
        return this.element.diy_calloutLayer('widget');
    }
 });

module.exports = MaintenanceMode;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/maintenanceMode.js
 ** module id = 846
 ** module chunks = 0
 **/